import { useState } from 'react';
import ThemeToggle from '../base/ThemeToggle';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigateToAuth = (type: 'login' | 'register') => {
    if (type === 'login') {
      window.location.href = '/login.php';
    } else {
      window.location.href = '/login.php';
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/c7e28c55-5702-4a14-b096-1992227f97e4.png" 
              alt="AbiSoft Explorer Logo" 
              className="w-10 h-10 rounded-lg"
            />
            <span className="text-2xl font-bold text-gray-900 dark:text-white">
              AbiSoft Explorer
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#inicio" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap cursor-pointer">
              Inicio
            </a>
            <a href="#caracteristicas" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap cursor-pointer">
              Características
            </a>
            <a href="#precios" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap cursor-pointer">
              Precios
            </a>
            <a href="#faq" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap cursor-pointer">
              FAQ
            </a>
            <a href="#contacto" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap cursor-pointer">
              Contacto
            </a>
          </nav>

          {/* Right Side */}
          <div className="flex items-center space-x-4">
            <ThemeToggle />
            
            <div className="hidden md:flex items-center space-x-3">
              <button
                onClick={() => navigateToAuth('login')}
                className="px-4 py-2 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Iniciar Sesión
              </button>
              <button
                onClick={() => navigateToAuth('register')}
                className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Registrarse
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 text-gray-700 dark:text-gray-300 hover:text-blue-600 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200 dark:border-gray-700">
            <div className="flex flex-col space-y-4">
              <a href="#inicio" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 cursor-pointer">
                Inicio
              </a>
              <a href="#caracteristicas" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 cursor-pointer">
                Características
              </a>
              <a href="#precios" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 cursor-pointer">
                Precios
              </a>
              <a href="#faq" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 cursor-pointer">
                FAQ
              </a>
              <a href="#contacto" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 cursor-pointer">
                Contacto
              </a>
              <div className="flex flex-col space-y-2 pt-4 border-t border-gray-200 dark:border-gray-700">
                <button
                  onClick={() => navigateToAuth('login')}
                  className="px-4 py-2 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Iniciar Sesión
                </button>
                <button
                  onClick={() => navigateToAuth('register')}
                  className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all whitespace-nowrap cursor-pointer"
                >
                  Registrarse
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}